function initTechnologies() {
  const technologiesSwiper = new Swiper(".technologies__swiper", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    loopAdditionalSlides: 2,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 3000,
    freeMode: true,
    freeModeMomentum: false,

    breakpoints: {
      0: {
        spaceBetween: 15,
      },
      1280: {
        spaceBetween: 20,
      }
    }
  });
}

export { initTechnologies };